
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Sobre = lazy(() => import('../pages/sobre/page'));
const Servicos = lazy(() => import('../pages/servicos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/sobre',
    element: <Sobre />,
  },
  {
    path: '/servicos',
    element: <Servicos />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
